module.exports = __webpack_public_path__ + "img/Visible-patient-no.0f89b2bf.png";